

























































































import { truncate } from 'lodash';
import { ref, PropType, defineComponent, watch } from '@vue/composition-api';
import { DirectiveOptions } from 'vue';

import { IAttachment } from '@/models';
import { fileToDataUrl } from '@/utils/fileUtils';
import { vResizeObserver } from '@vueuse/components';
import { humanReadableFileSize } from '@/utils/helpers';

export default defineComponent({
  name: 'CommentAttachmentList',

  directives: {
    ResizeObserver: vResizeObserver as DirectiveOptions
  },

  props: {
    attachments: {
      type: Array as PropType<IAttachment[]>,
      defaults: () => [],
      required: true
    },

    truncate: {
      type: Number,
      default: () => null
    }
  },

  setup(props, { emit, root }) {
    type FileData = {
      type: 'image' | 'text' | 'other';
      fileUrl: string;
      fileName: string;
      fileSize: number;
    };

    type AttachmentFileData = {
      attachment: IAttachment;
    } & FileData;

    const attachmentFileDataList = ref<AttachmentFileData[]>([]);

    function truncateFileName(filename: string) {
      const extension = filename.split('.').pop()!;

      return !props.truncate
        ? filename
        : `${truncate(filename, {
            length: props.truncate
          })}${extension}`;
    }

    watch(
      () => props.attachments,
      async value => {
        if (!value) return;

        const list: AttachmentFileData[] = [];
        for (let index = 0; index < value.length; index++) {
          const attachment = value[index];

          const fileData = await loadFileContentFromAttachment(attachment);

          list.push({
            attachment: attachment,
            type: fileData.type,
            fileUrl: fileData.fileUrl,
            fileName: fileData.fileName,
            fileSize: fileData.fileSize
          });
        }

        attachmentFileDataList.value = list;
      },
      {
        deep: true,
        immediate: true
      }
    );

    function removeAttachment(index: number) {
      emit('remove-attachment', index);
    }

    function loadAttachmentFile(attachment: string) {
      return root.$services.fileLoader.downloadFile(attachment);
    }

    async function loadFileContentFromAttachment(
      attachment: IAttachment
    ): Promise<FileData> {
      let attachmentFile = attachment.file;

      let fileName = '';

      if (typeof attachmentFile === 'string') {
        fileName = attachment.filename;
        const blob = await loadAttachmentFile(attachmentFile);
        attachmentFile = new File([blob], fileName, { type: blob.type });
      }

      fileName = attachmentFile.name;

      let fileType: FileData['type'] = 'other';
      let fileUrl = URL.createObjectURL(attachmentFile);

      if (attachmentFile.type.startsWith('image/')) {
        fileType = 'image';
        fileUrl = await fileToDataUrl(attachmentFile);
      }

      return {
        type: fileType,
        fileUrl: fileUrl,
        fileSize: attachmentFile.size,
        fileName: fileName
      };
    }

    const contentWidth = ref(0);

    function onResizeObserver(entries: ReadonlyArray<ResizeObserverEntry>) {
      const [entry] = entries;
      const { width } = entry.contentRect;
      contentWidth.value = width ?? 500;
    }

    return {
      contentWidth,
      truncateFileName,
      attachmentFileDataList,
      removeAttachment,
      onResizeObserver,
      humanReadableFileSize
    };
  }
});
